import React from "react";

import {
    Banner,
    Button,
    FieldGrid,
    LabeledField,
    RadioGroup,
    SectionCard,
    Stack,
    TextInput,
} from "shared/ui";

import { LEGAL_FORM_OPTIONS } from "features/Tariff/constants";
import { useTariffContext } from "features/Tariff/context";
import { LegalDataFormField } from "features/Tariff/types";

export const BillingDetailsTab = () => {
    const state = useTariffContext();
    const { form } = state;

    const isCompany = form.type === "RussianOOOCard";

    const field = (
        label: string,
        name: LegalDataFormField,
        placeholder?: string,
        hint?: string
    ) => {
        const error = state.fieldError(name);

        return (
            <LabeledField
                label={label}
                hint={error || hint}
                hintTone={error ? "danger" : "default"}
            >
                <TextInput
                    value={form[name]}
                    onChange={(value) => state.setFormField(name, value)}
                    placeholder={placeholder}
                />
            </LabeledField>
        );
    };

    return (
        <SectionCard
            title="Реквизиты для счёта"
            description="По этим данным формируются счета и акты"
        >
            <Stack $gap={20}>
                {!state.legalData && (
                    <Banner tone="warning" title="Реквизиты не заполнены">
                        Пока их нет, счёт на оплату тарифа выставить не получится — доступна
                        только оплата картой.
                    </Banner>
                )}

                <RadioGroup
                    value={form.type}
                    options={LEGAL_FORM_OPTIONS}
                    onChange={(value) => state.setFormField("type", value)}
                />

                {field("Название организации", "title", isCompany ? "ООО «Ромашка»" : "ИП Иванов И. И.")}

                <FieldGrid $min={240}>
                    {field("ИНН", "inn")}
                    {isCompany ? field("КПП", "kpp") : field("ОГРНИП", "ogrnip")}
                    {isCompany && field("ОГРН", "ogrn")}
                </FieldGrid>

                {field("Банк", "bankTitle", "АО «Тинькофф Банк»")}

                <FieldGrid $min={240}>
                    {field("БИК", "bankBik")}
                    {field("Расчётный счёт", "bankCurrentAccountNumber")}
                    {field("Корреспондентский счёт", "bankCorrespondentAccountNumber")}
                </FieldGrid>

                <div>
                    <Button
                        disabled={!state.isFormValid || state.saving}
                        onClick={state.saveLegalData}
                    >
                        Сохранить
                    </Button>
                </div>
            </Stack>
        </SectionCard>
    );
};
